import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter } from "react-router-dom"
import { Uprovider } from './context/Ucontext'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <Uprovider>
        <App />
      </Uprovider>
    </BrowserRouter>
  </StrictMode>
)